import type { HistoricalInspection, InspectionDetails } from '@areapif/areapif-shared'
import { createInspectionDetails, photoToEvidence, sealToEvidence } from '@areapif/areapif-shared'

export type { HistoricalInspection }

/**
 * Convert raw database record to InspectionDetails object
 */
export const convertToInspection = (data: HistoricalInspection): InspectionDetails => {
  // Convert photos to Evidence array
  const photoEvidences = data.photos.map(photo =>
    photoToEvidence({
      id: photo.path ?? '',
      category: photo.category ?? 'OTHERS',
      createdAt: Date.now(),
    }),
  )

  // Convert seals to Evidence array
  const sealEvidences = data.seals.map(seal =>
    sealToEvidence({
      id: seal.path ?? '',
      category: seal.category ?? 'OUTRO',
      createdAt: Date.now(),
      serialId: seal.serial_id ?? '',
      requestMetadata: {},
    }),
  )

  const allEvidences = [...photoEvidences, ...sealEvidences]

  // Create InspectionDetails object
  // `location` drives the RP terminal flow in shared 5.x; a historical record
  // carries no dock, so that argument stays undefined.
  return createInspectionDetails(data.id, data.container, data.inspection_level, 'FINALIZADO', allEvidences, undefined, data.location)
}
